import React from 'react';
import { useLocation } from "react-router-dom";

const Footer = () => {

    const location = useLocation();
    const pathname = location.pathname;

    const allPathEdit = pathname.split("/");

    if (location.pathname === "/" || location.pathname === "/forgetPassword" || location.pathname === "/confirmPassword" || allPathEdit[2] === "confirmPassword") {
        return null
    }
    else {
        return (
            <footer className="footerside margin_top">
                <h5 className="footercont">Copyright ©{new Date().getFullYear()} drotly Inc. All Rights Reserved.</h5>
            </footer>
        )
    }
}

export default Footer
